import {z} from 'zod'

export const loadBalanceSchema = z.object({
  maxLoadSize: z.number().optional()
})
